import React from 'react';
import PropTypes from 'prop-types';
import { Modal, Spinner } from 'next/components/ui';

import { UnpublishingWrapper, Name } from './styled';

export default function RequestingModal({ visible, content }) {
  return (
    <Modal visible={visible} size="s">
      <UnpublishingWrapper>
        <Spinner />
        <Name>{content}</Name>
      </UnpublishingWrapper>
    </Modal>
  );
}

RequestingModal.propTypes = {
  visible: PropTypes.bool,
  content: PropTypes.node,
};
